const AbstractVerifoneResponseRecord = require('./AbstractVerifoneResponseRecord');

class VerifoneLoginResponseRecord extends AbstractVerifoneResponseRecord {

}

module.exports = VerifoneLoginResponseRecord;
